import React, { useState, useEffect } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

const SendMessage = ({ lead, onClose }) => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [messageType, setMessageType] = useState('email');
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');

  useEffect(() => {
    fetchTemplates();
  }, [messageType]);

  const fetchTemplates = async () => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens.idToken.toString();
      
      const response = await fetch(`https://hjjtpav7x0.execute-api.us-east-1.amazonaws.com/prod/admin/templates?type=${messageType}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setTemplates(data);
      }
    } catch (error) {
      console.error('Error fetching templates:', error);
    }
  };

  const handleTemplateSelect = (templateId) => {
    const template = templates.find(t => t.templateId === templateId);
    if (template) {
      setSelectedTemplate(templateId);
      setSubject(template.subject || '');
      setContent(personalizeContent(template.content));
    }
  };

  const personalizeContent = (templateContent) => {
    return templateContent
      .replace(/\{firstName\}/g, lead.firstName || 'there')
      .replace(/\{lastName\}/g, lead.lastName || '')
      .replace(/\{fullName\}/g, lead.fullName || lead.firstName || 'there')
      .replace(/\{address\}/g, lead.address || '')
      .replace(/\{email\}/g, lead.email || '');
  };

  const handleSend = async () => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens.idToken.toString();
      
      const payload = {
        leadId: lead.qrCode,
        type: messageType,
        subject: messageType === 'email' ? subject : undefined,
        content,
        templateId: selectedTemplate
      };
      
      const response = await fetch('https://hjjtpav7x0.execute-api.us-east-1.amazonaws.com/prod/admin/send-message', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });
      
      if (response.ok) {
        alert(`${messageType} sent successfully!`);
        onClose();
      } else {
        alert(`Failed to send ${messageType}`);
      }
    } catch (error) {
      console.error('Error sending message:', error);
      alert(`Error sending ${messageType}`);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        minWidth: '500px',
        maxWidth: '600px'
      }}>
        <h3>Send Message to {lead.fullName || lead.firstName || 'Lead'}</h3>
        
        <div style={{ marginBottom: '15px' }}>
          <label>Message Type:</label>
          <select 
            value={messageType} 
            onChange={(e) => setMessageType(e.target.value)}
            style={{
              width: '100%',
              marginTop: '5px',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px'
            }}
          >
            <option value="email">Email</option>
            <option value="sms">SMS</option>
          </select>
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label>Template:</label>
          <select 
            value={selectedTemplate} 
            onChange={(e) => handleTemplateSelect(e.target.value)}
            style={{
              width: '100%',
              marginTop: '5px',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px'
            }}
          >
            <option value="">Select a template...</option>
            {templates.map(template => (
              <option key={template.templateId} value={template.templateId}>
                {template.name}
              </option>
            ))}
          </select>
        </div>
        
        {messageType === 'email' && (
          <div style={{ marginBottom: '15px' }}>
            <label>Subject:</label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
              style={{
                width: '100%',
                marginTop: '5px',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }}
            />
          </div>
        )}
        
        <div style={{ marginBottom: '15px' }}>
          <label>Content:</label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            rows="8"
            required
            style={{
              width: '100%',
              marginTop: '5px',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              resize: 'vertical'
            }}
          />
          {messageType === 'sms' && (
            <div style={{ 
              fontSize: '12px', 
              color: content.length > 160 ? '#e74c3c' : '#666',
              marginTop: '5px'
            }}>
              {content.length}/160 characters
              {content.length > 160 && (
                <span style={{ color: '#e74c3c', marginLeft: '10px' }}>
                  ({Math.ceil(content.length / 160)} SMS segments)
                </span>
              )}
            </div>
          )}
        </div>
        
        <div style={{ textAlign: 'right' }}>
          <button 
            onClick={onClose}
            style={{ marginRight: '10px', padding: '8px 16px' }}
          >
            Cancel
          </button>
          <button 
            onClick={handleSend}
            style={{ 
              padding: '8px 16px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px'
            }}
          >
            Send {messageType}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendMessage;
